import { Input, Modal, message } from 'antd';
import { useEffect, useState } from 'react';
import css from './modal.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { custome } from '@/constants/solar-calculator';

export default function ApplianceModal({ config = {}, item = custome, onCancel, onConfirm, type = 'edit' }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('calculatorssolarpanels');
    const defaultProps = {
        width: '3.75rem',
        centered: true,
        closable: false,
        wrapClassName: css.calculatorssolarstep3modal,
        cancelText: s(`step3_modal_cancel`),
        okText: s(`step3_modal_confirm`),
        // onCancel: onCancel,
        onOk: () => !disable && onConfirm(data, type),
    };
    const modalProps = { ...defaultProps, ...config };
    const [data, setData] = useState(type === 'add' ? custome : { ...item });
    const MAX_POWER = 10000;
    const [disable, setDisable] = useState(false);

    useEffect(() => {
        setData({ ...item });
    }, [item]);

    const changeValue = (e: any, type: string) => {
        // 校验： 不能为非数字, 不可小于0, 不可为小数
        const value = Number(e.target.value);
        if (String(value) === 'NaN' || value < 0 || value % 1 !== 0) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        // 小时不可大于24
        if (type === 'h' && value > 24) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        // 分钟不可大于等于60
        if (type === 'm' && value >= 60) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        // 24小时时，分钟只能为0
        if (Number(data?.time?.h) === 24 && type === 'm' && value !== 0) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }

        if (type === 'power') {
            if (value > MAX_POWER) {
                return message.error(t(`calculators.mm100.step3.vali_error_max`));
            }
            return setData({
                ...data,
                power: value,
                desc: data?.desc?.replace(String(data?.power), value),
            });
        }
        if (type === 'h') {
            return setData({
                ...data,
                time: { h: value, m: data?.time?.m, t: value + data?.time?.m / 60 },
                desc: `${data?.power}${s('step3_modal_power_unit')}/${
                    value === 0 ? '' : value + (value === 1 ? t('calculators.mm100.step3.time_h_s') : t('calculators.mm100.step3.time_h'))
                }${Number(data?.time?.m) === 0 ? '' : Number(data?.time?.m) + t('calculators.mm100.step3.time_m')}${t('calculators.mm100.step3.per_day')}`,
            });
        }
        if (type === 'm') {
            return setData({
                ...data,
                time: { h: data?.time?.h, m: value, t: Number(data?.time?.h) + value / 60 },
                desc: `${data?.power}${s('step3_modal_power_unit')}/${
                    Number(data?.time?.h) === 0
                        ? ''
                        : Number(data?.time?.h) + (data?.time?.h === 1 ? t('calculators.mm100.step3.time_h_s') : t('calculators.mm100.step3.time_h'))
                }${value === 0 ? '' : value + t('calculators.mm100.step3.time_m')}${t('calculators.mm100.step3.per_day')}`,
            });
        }
    };

    useEffect(() => {
        if (['0', '00'].includes(data?.time?.h) && ['0', '00'].includes(data?.time?.m) && ['0', '00', '000', 0].includes(data?.power)) {
            !disable && setDisable(true);
        } else {
            disable && setDisable(false);
        }
    }, [data?.time, data?.power]);

    return (
        <Modal {...modalProps} className={`${disable ? 'disable' : ''}`}>
            <svg className="close" xmlns="http://www.w3.org/2000/svg" width=".28rem" height=".28rem" viewBox="0 0 32 32" fill="none" onClick={onCancel}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16ZM1.8 16C1.8 8.15756 8.15756 1.8 16 1.8C23.8424 1.8 30.2 8.15756 30.2 16C30.2 23.8424 23.8424 30.2 16 30.2C8.15756 30.2 1.8 23.8424 1.8 16Z"
                    fill="black"
                />
                <path
                    d="M10.3767 20.271C9.8849 20.7217 9.87466 21.1828 10.3459 21.6541C10.8172 22.1253 11.2783 22.1151 11.729 21.6233L16 17.4138L20.271 21.6233C20.7217 22.1151 21.1828 22.1253 21.6541 21.6541C22.1253 21.1828 22.1151 20.7217 21.6233 20.271L17.4138 16L21.6233 11.729C22.1151 11.2783 22.1253 10.8172 21.6541 10.3459C21.1828 9.87466 20.7217 9.88491 20.271 10.3767L16 14.5862L11.729 10.3767C11.2783 9.88491 10.8172 9.87466 10.3459 10.3459C9.87466 10.8172 9.8849 11.2783 10.3767 11.729L14.5862 16L10.3767 20.271Z"
                    fill="black"
                />
            </svg>
            <div className="appTitle">
                <div className="titleIcon">{data?.icon}</div>
                <span className="title">{s(`step3_icon_${data?.i18n}`)}</span>
            </div>
            <div className="ratePowerBox middleBox">
                <div className="textBox">
                    <span className="text">{s('step3_modal_power')}</span>
                    <div className="inputBox">
                        <Input value={data?.power} onChange={(e: any) => changeValue(e, 'power')} />
                        <span className="unit">{s('step3_modal_power_unit')}</span>
                    </div>
                </div>
                <p className="desc">{s('step3_modal_power_desc')}</p>
            </div>
            <div className="timeBox middleBox">
                <div className="textBox">
                    <span className="text">{s('step3_modal_time')}</span>
                    <div className="inputBox">
                        <Input value={data?.time?.h} onChange={(e: any) => changeValue(e, 'h')} />
                        <span className="unit">{Number(data?.time?.h) === 1 ? s('step3_modal_time_h_s') : s('step3_modal_time_h')}</span>
                        <Input value={data?.time?.m} onChange={(e: any) => changeValue(e, 'm')} />
                        <span className="unit">{Number(data?.time?.m) === 1 ? s('step3_modal_time_m_s') : s('step3_modal_time_m')}</span>
                    </div>
                </div>
                <p className="desc">{s('step3_modal_time_desc')}</p>
            </div>
        </Modal>
    );
}
